import React, { createContext, useState, useContext } from 'react'

export const LoadingContext = createContext()

export const useLoading = () => {
    return useContext(LoadingContext)
}

export const LoadingProvider = ({ children }) => {
    const [loading, setLoading] = useState(false)

    return (
        <LoadingContext.Provider value={{ loading, setLoading }}>
            {children}
        </LoadingContext.Provider>
    )
}
